<script>
export default {
    page() {
        const title = 'Your Genres'
        const description = 'Your Genres'
        return {
            title,
            meta: [
                { name: 'title', vmid: 'title', content: title },
                { name: 'description', vmid: 'description', content: description },

                { property: 'og:title', vmid: 'og:title', content: title },
                { property: 'og:description', vmid: 'og:description', content: description },

                { property: 'twitter:title', vmid: 'twitter:title', content: title },
                { property: 'twitter:description', vmid: 'twitter:description', content: description },
            ],
        }
    },
}
</script>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { useStore } from '@state/composables'
import DataLayer from './../../services/data-layer/index'
import Layout from './../layouts/main'
import GenreGridBlock from '@components/genre/genre-grid-block'
import LibraryHeader from '@components/library/library-header'
import LibrarySearchResults from '@components/library/library-search-results'
import LibrarySectionTabs from '@components/library/library-section-tabs'

const store = useStore()

const isLoading = ref(false)
const allGenres = ref([])
const searchQuery = ref('')

const followedGenreIds = computed(() => store.getters['favorites/genreIds'])
const genres = computed(() => allGenres.value.filter(genre => followedGenreIds.value.includes(genre.id)))

onMounted(async () => {
    isLoading.value = true
    const [genresRes] = await Promise.all([
        DataLayer.genres.getAll(),
        store.dispatch('favorites/fetchType', 'genres'),
    ])
    allGenres.value = genresRes.body || []
    isLoading.value = false
})

function handleToggleFollow(genre) {
    return store.dispatch('favorites/remove', { type: 'genres', id: genre.id })
}
</script>

<template>
    <Layout>
        <BaseContent>
            <BaseSection padded>
                <LibraryHeader
                    title="Your Genres"
                    :count="isLoading ? null : followedGenreIds.length"
                    count-label="genres"
                    :search-query="searchQuery"
                    @update:search-query="searchQuery = $event"
                />
                <LibrarySearchResults
                    v-if="searchQuery.trim()"
                    :query="searchQuery"
                />
                <template v-else>
                    <LibrarySectionTabs />
                    <BaseSpinner v-if="isLoading" />
                    <GenreGridBlock
                        v-else-if="genres.length > 0"
                        :genres="genres"
                        :followed-genre-ids="followedGenreIds"
                        @toggle-follow="handleToggleFollow"
                    />
                    <BaseEmptyList
                        v-else
                        :error="{
                            title: `You are not following any genres.`,
                            paragraph: 'Following genres helps us recommend similar genres.',
                        }"
                    />
                </template>
            </BaseSection>
        </BaseContent>
    </Layout>
</template>
